import { KeyValueModel } from "model/api";
import { EnumTipoPessoas } from "model/enums/enum-tipo-pessoas";

export const TipoPessoaMock: KeyValueModel[] = [
    new KeyValueModel(EnumTipoPessoas.Cliente, "Cliente"),
    new KeyValueModel(EnumTipoPessoas.Revendedor, "Revendedor"),
    new KeyValueModel(EnumTipoPessoas.AgenteExterno, "Agente Externo"),
    new KeyValueModel(EnumTipoPessoas.FinanceiroSoftwareHouse, "Financeiro Software House"),
    new KeyValueModel(EnumTipoPessoas.FinanceiroSoftwareHouseSemCusto, "Financeiro Software House Sem Custo"),
    new KeyValueModel(EnumTipoPessoas.Funcionario, "Funcionário"),
    new KeyValueModel(EnumTipoPessoas.FuncionarioFinanceiro, "Funcionário Financeiro"),
    new KeyValueModel(EnumTipoPessoas.FuncionarioFinanceiroSemCusto, "Funcionário Financeiro Sem Custo"),
    new KeyValueModel(EnumTipoPessoas.FuncionarioSoftwareHouse, "Funcionário Software House"),
    new KeyValueModel(EnumTipoPessoas.GerenteComercial, "Gerente Comercial"),
    new KeyValueModel(EnumTipoPessoas.Prospeccao, "Prospecção"),
    new KeyValueModel(EnumTipoPessoas.Representante, "Representante"),
    new KeyValueModel(EnumTipoPessoas.Revendedor, "Revendedor"),
    new KeyValueModel(EnumTipoPessoas.SoftwareHouse, "Software House"),
];

export const TipoPessoaMockTodos: KeyValueModel[] = [
    new KeyValueModel(EnumTipoPessoas.Cliente, "Cliente"),
    new KeyValueModel(EnumTipoPessoas.Revendedor, "Revendedor"),
    new KeyValueModel(-1, "Todos"),
];